const subscribers = /* @__PURE__ */ new Set();
function canStartMobileAutoplay() {
  var _a;
  return Boolean(((_a = window.Shopify) == null ? void 0 : _a.designMode) || window.__bearPlaybackIntent);
}
function notifyPermissionChange() {
  subscribers.forEach((callback) => callback());
}
function onMobileAutoplayPermissionChange(callback) {
  subscribers.add(callback);
  if (subscribers.size === 1) {
    window.addEventListener("bear:playback-intent", notifyPermissionChange);
  }
  return () => {
    subscribers.delete(callback);
    if (!subscribers.size) {
      window.removeEventListener("bear:playback-intent", notifyPermissionChange);
    }
  };
}
export {
  canStartMobileAutoplay,
  onMobileAutoplayPermissionChange
};
